import { configureStore } from '@reduxjs/toolkit';
import themeSettingSlice from './themeSettingSlice';
import sidebarSlice from './sidebarSlice';
import { AuthApiSlice, HomeMenuApiSlice, UserApiSlice, HomePageApiSlice, StudyAbroadStepsApiSlice, StudyDestinationApiSlice, CourseAdviceApiSlice, StudyAbroadCoursesApiSlice, IndividualSubjectApiSlice, ScholarshipsApiSlice, UniversityApiSlice, UniversityRankingsApiSlice, EducationLoanApiSlice, StudyHealthCoverApiSlice, FormApiSlice, ContactApiSlice, LearnMoreApiSlice } from "../Features/api/index.js";
import { setupListeners } from "@reduxjs/toolkit/query";
import userReducer from '../Features/slice.js';
import commonReducer from '../Features/commonSlice';

const store = configureStore({
  reducer: {
    themeSetting: themeSettingSlice,
    sidebarSlice: sidebarSlice,
    [AuthApiSlice.reducerPath]: AuthApiSlice.reducer,
    [HomeMenuApiSlice.reducerPath]: HomeMenuApiSlice.reducer,
    [UserApiSlice.reducerPath]: UserApiSlice.reducer,
    [HomePageApiSlice.reducerPath]: HomePageApiSlice.reducer,
    [StudyAbroadStepsApiSlice.reducerPath]: StudyAbroadStepsApiSlice.reducer,
    [StudyDestinationApiSlice.reducerPath]: StudyDestinationApiSlice.reducer,
    [CourseAdviceApiSlice.reducerPath]: CourseAdviceApiSlice.reducer,
    [StudyAbroadCoursesApiSlice.reducerPath]: StudyAbroadCoursesApiSlice.reducer,
    [IndividualSubjectApiSlice.reducerPath]: IndividualSubjectApiSlice.reducer,
    [ScholarshipsApiSlice.reducerPath]: ScholarshipsApiSlice.reducer,
    [UniversityApiSlice.reducerPath]: UniversityApiSlice.reducer,
    [UniversityRankingsApiSlice.reducerPath]: UniversityRankingsApiSlice.reducer,
    [EducationLoanApiSlice.reducerPath]: EducationLoanApiSlice.reducer,
    [StudyHealthCoverApiSlice.reducerPath]: StudyHealthCoverApiSlice.reducer,
    [FormApiSlice.reducerPath]: FormApiSlice.reducer,
    [ContactApiSlice.reducerPath]: ContactApiSlice.reducer,
    [LearnMoreApiSlice.reducerPath]: LearnMoreApiSlice.reducer,
    user: userReducer,
    common: commonReducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      AuthApiSlice.middleware,
      HomeMenuApiSlice.middleware,
      UserApiSlice.middleware,
      HomePageApiSlice.middleware,
      StudyAbroadStepsApiSlice.middleware,
      StudyDestinationApiSlice.middleware,
      CourseAdviceApiSlice.middleware,
      StudyAbroadCoursesApiSlice.middleware,
      IndividualSubjectApiSlice.middleware,
      ScholarshipsApiSlice.middleware,
      UniversityApiSlice.middleware,
      UniversityRankingsApiSlice.middleware,
      EducationLoanApiSlice.middleware,
      StudyHealthCoverApiSlice.middleware,
      FormApiSlice.middleware,
      ContactApiSlice.middleware,
      LearnMoreApiSlice.middleware,
    ),
}
);

export default store;

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
